import { isFarmBasedPolicyType, policyTypes } from '@ourbranch/policy-types';
import { appConfig } from 'brand-config';

/**
 * Which pipeline renders the staff "Quote PDF" for an offer option (#35921).
 *
 * Two pipelines exist behind the one button:
 *   - Zywave DocGen: `generateApplicationDraft` with docContext 'quote' — the brand's own filed
 *     DOCX template, rendered by docs-engine. Farm-based types (F/Z/Y) always go here, and so does
 *     standalone Auto (A) on a brand whose auto documents are stood up in Zywave
 *     (brand-config-be `autoDocGenTemplateId`, mirrored on the FE by the
 *     `autoQuotePdfViaDocGen` feature flag — CFM, #34154).
 *   - react-pdf: `getDocraptorDocument` renders the Branch offer document from the offerId,
 *     gated by USE_REACT_PDF_OFFERS.
 *
 * Auto bundles (HA/AR/...) stay on the react-pdf path: docs-engine's application-handler only routes
 * `policyTypes.Auto` to the auto DocGen manager.
 */
export function usesDocGenQuotePdf(policyType) {
  if (isFarmBasedPolicyType(policyType)) {
    return true;
  }
  return policyType === policyTypes.Auto && appConfig.featureFlags?.autoQuotePdfViaDocGen === true;
}
